// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pendingCommitId: __t.u64().primaryKey().name("pending_commit_id"),
  workspaceId: __t.u64().name("workspace_id"),
  messageId: __t.u64().name("message_id"),
  attachmentId: __t.u64().name("attachment_id"),
  repo: __t.string(),
  branch: __t.string(),
  commitMessage: __t.string().name("commit_message"),
  filesJson: __t.string().name("files_json"),
  status: __t.string(),
  createdAt: __t.i64().name("created_at"),
  approvedAt: __t.i64().name("approved_at"),
  rejectedAt: __t.i64().name("rejected_at"),
  pushedSha: __t.string().name("pushed_sha"),
});
